<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-spinner v-if="!ready"/>
        <hm-alert/>
        <component :is="component" :data="data" v-if="component"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { trainingService } from '@/services'
import Enumerable from 'linq/linq.js'

export default {
  name: 'Print.TrainingPrint',
  props: ['type'],
  data() {
    return {
      data: {},
      dataLoaded: false,
      file: '',
      component: null,
      ready: false
    }
  },
  computed: {
    ...mapState('maps', ['trainingMap'])
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertError: 'alert/error',
      alertException: 'alert/exception'
    }),
    onLoad() {
      this.ready = false;
      this.alertClear();

      this.$store.dispatch('maps/fetchTrainingMap')
        .then(() => {
          if (this.type && this.trainingMap.Training.hasOwnProperty(this.type)) {
            this.file = this.trainingMap.Training[this.type].file;

            return trainingService.getTrainingDocument(this.type)
              .then(data => {
                this.data = data;
                this.dataLoaded = true;
              })
              .catch(err => {
                this.alertException({ err, message: 'Error loading training document.' });
              });
          } else {
            this.alertError('Invalid training document type.');
            return this.data;
          }
        }).then(() => {
          if (this.file) {
            return trainingService.getTrainingFile(this.file)
              .then(data => {
                // make a custom component with the policy file as the template
                this.component = {
                  template: '<div>' + data + '</div>',
                  props: ['data'],
                  inject: ['$validator'],
                  data() {
                    return {}
                  }
                }
              }).catch(err => {
                this.alertException({ err, message: 'Error loading training file.' });
              });
          }
        }).catch((err) => {
          this.alertException({ err, message: 'Error loading data.' });
        }).finally(() => {
          this.ready = true;
        })
    }
  },
  created() {
    return this.onLoad();
  },
  watch: { // you have to use function syntax here, as warned in the docs
    '$route.params.type': function (newVal, oldVal) {
      this.onLoad();
    }
  }
}
</script>


<style lang="scss">
// import variables for this application
@import '@/assets/scss/_variables.scss';

.training-highlight {
  color: $highlight-color;
  background-color: $highlight-bg;
  display: inline;
}
.training-highlight-pre {
  color: $highlight-color;
  background-color: $highlight-bg;
  white-space: pre-wrap;
}
</style>